import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const LINKS = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Approach',
  href: '#approach'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-ivory/90 backdrop-blur-md border-b border-navy/10 py-3' : 'bg-transparent py-5'}`} data-id="element-108" data-mp="ekz4sy7r0yne">
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-109" data-mp="1q0dzfvchjefc">
        <a href="#top" aria-label="Flicker Africa home" data-id="element-110" data-mp="1kz873ymqlt6c">
          <Logo variant={scrolled ? 'dark' : 'light'} data-id="element-111" data-mp="9p93ryclpr1f" />
        </a>

        <div className="hidden md:flex items-center gap-8" data-id="element-112" data-mp="enkfkemgibma">
          {LINKS.map(l => <a key={l.href} href={l.href} className={`text-sm font-medium tracking-wide transition-colors ${scrolled ? 'text-graphite hover:text-navy' : 'text-ivory/80 hover:text-ivory'}`} data-id="element-113" data-mp="epdoy1ogf9xz">
              {l.label}
            </a>)}
          <a href="#contact" className="text-sm font-semibold px-5 py-2.5 rounded-full bg-gold text-navy hover:bg-gold/90 transition-colors" data-id="element-114" data-mp="3s2yu91o4vrf0">
            Let's Talk
          </a>
        </div>

        <button className={`md:hidden ${scrolled ? 'text-navy' : 'text-ivory'}`} onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-115" data-mp="5op9r3nbr3ji">
          {open ? <XIcon size={26} data-id="element-116" data-mp="31ahwj0154s92" /> : <MenuIcon size={26} data-id="element-117" data-mp="319ynk8tgxe76" />}
        </button>
      </nav>

      {open && <div className="md:hidden bg-ivory border-t border-navy/10 mt-3" data-id="element-118" data-mp="2wcygpvoso7f0">
          <div className="px-6 py-4 flex flex-col gap-1" data-id="element-119" data-mp="3b0tcjky3mrwb">
            {LINKS.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-3 text-navy font-medium border-b border-navy/5" data-id="element-120" data-mp="3620261e3zh0d">
                {l.label}
              </a>)}
            <a href="#contact" onClick={() => setOpen(false)} className="mt-4 text-center text-sm font-semibold px-5 py-3 rounded-full bg-gold text-navy" data-id="element-121" data-mp="2dffa0ypt70vr">
              Let's Talk
            </a>
          </div>
        </div>}
    </header>;
}